// Iter-f9 — Shared info-icon helper for Overview dashboard summary
// cards and chart cards. Renders a tiny (i) icon that reveals the
// supplied explanation on hover (via the native `title` tooltip so
// no global TooltipProvider is required anywhere).
//
// Keep the markup minimal: an absolutely-positioned button in the
// top-right corner so adding `<InfoHint>` into an existing card is
// a one-liner that never shifts the existing layout.
import React from "react";
import { Info } from "lucide-react";

export function InfoHint({ text, testId, className = "" }) {
  if (!text) return null;
  return (
    <button
      type="button"
      aria-label={text}
      title={text}
      tabIndex={0}
      className={`absolute top-2 right-2 inline-flex items-center justify-center h-4 w-4 rounded-full text-muted-foreground/70 hover:text-foreground focus:text-foreground focus:outline-none ${className}`}
      data-testid={testId}
      onClick={(e) => e.stopPropagation()}
    >
      <Info className="h-3.5 w-3.5" />
    </button>
  );
}

// Inline variant — flows alongside a label instead of absolute-pinning
// to a card corner. Handy inside sub-metric cells on branch cards.
export function InfoHintInline({ text, testId, className = "" }) {
  if (!text) return null;
  return (
    <button
      type="button"
      aria-label={text}
      title={text}
      tabIndex={0}
      className={`inline-flex items-center justify-center h-3.5 w-3.5 rounded-full text-muted-foreground/70 hover:text-foreground focus:text-foreground focus:outline-none align-middle ${className}`}
      data-testid={testId}
      onClick={(e) => e.stopPropagation()}
    >
      <Info className="h-3 w-3" />
    </button>
  );
}
